import React from 'react';
import { Card } from "react-bootstrap";
import face_gergo_orban from "../../assets/img/face_gergo_orban.jpg";
import ShowMoreText from "react-show-more-text";
import proj_investigation_of_comp_in_brain from "../../assets/img/proj_investigation_of_comp_in_brain_fixed.png";

const Gergo_Orban_brain = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_investigation_of_comp_in_brain} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_gergo_orban}
              /* this will be the text on the banner */
              alt="Investigation of computations in the visual system of the brain based on electrophysiological data"
            />{" "}
            <p className="text7">Gergő Orbán</p>
            <br />
            <p className="text8">
              Group Leader{" "}
            </p>
            <p className="text8">Wigner Research Centre for Physics</p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            Neural circuitries in the visual system of the brain solve complex tasks, 
            such as recognizing and categorizing objects based on retinal images. 
            Investigations in neuroscience has largely been constrained to the computations 
            performed in early processing stages of the visual system, but the specifics of 
            computations taking place in higher visual areas are little-known. Recent results 
            from machine learning have achieved unprecedented success in solving problems 
            similar to those faced by the biological brain. This achievement contributed to 
            understanding the algorithms potentially used by the brain. Parallel to this, 
            access to unprecedented granularity data has been provided by novel recording 
            technologies. As we record the activity of hundreds of neurons, a new challenge 
            has emerged: there is a burning need for tools to interpret this data. Dimension 
            reduction approaches rely on machine learning tools in order to make neural dynamics 
            interpretable: these tools ensure that we can track trial-by-trial the behavior of 
            otherwise noisy responses of neurons. Such tools thus make possible to predict the 
            behavior of humans or other animals, a core component of brain-machine interfacing.

            <br />
            <br />

            The project provides an opportunity to get acquainted with state-of-the art tools 
            for interpreting complex data and to have an understanding of the math behind 
            brain-machine interfacing.

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Gergo_Orban_brain;